// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul{
    margin: 0px;
    padding: 0px;
  }
  
  ul li{
    list-style-type: none;
    border-bottom: dashed 1px #e4e8ee;
  }

  ul li:not(:last-child){
    border-bottom: dashed 1px #e4e8ee;
  }`, "",{"version":3,"sources":["webpack://./src/app/views/pages/add-page-to-menu/add-page-to-menu.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC","sourcesContent":["ul{\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n  \r\n  ul li{\r\n    list-style-type: none;\r\n    border-bottom: dashed 1px #e4e8ee;\r\n  }\r\n\r\n  ul li:not(:last-child){\r\n    border-bottom: dashed 1px #e4e8ee;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
